export default __webpack_public_path__ + "static/media/warning.7202aa38.svg";